import React from 'react';
import { Col, Icon, Row } from 'antd';
import styled from 'styled-components/macro';

import Description from 'components/Description/Description';
import Heading from 'components/Heading/Heading';

const StyledRow = styled(Row)`
  margin-top: 48px;
`;

const StyledCol = styled(Col)`
  display: flex;
  line-height: 24px;
  word-break: break-word;
`;

const DetailsIcon = styled(Icon)`
  margin-right: 24px;
  font-size: 24px;
`;

const constructHostDetails = data => {
  const details = [];
  if (data.yearEstablished) {
    details.push({
      icon: 'idcard',
      text: `In service since ${data.yearEstablished}`
    });
  }

  if (data.unitsOnHand) {
    details.push({
      icon: 'home',
      text: `${data.unitsOnHand} unit${data.unitsOnHand > 1 ? 's' : ''}`
    });
  }

  if (data.coveredAreas) {
    details.push({
      icon: 'environment',
      text: data.coveredAreas.join(', ')
    });
  }

  if (data.website) {
    details.push({
      icon: 'link',
      text: data.website
    });
  }

  if (data.email) {
    details.push({
      icon: 'mail',
      text: data.email
    });
  }

  if (data.contact) {
    details.push({
      icon: 'phone',
      text: `${data.contact.countryCode} ${data.contact.contactNumber}`
    });
  }

  return details;
};

const DetailsSection = ({ hostDetails }) => {
  const details = constructHostDetails(hostDetails);
  return (
    <Row>
      <Heading size="sub">Overview</Heading>
      <Description color="lightGrey">{hostDetails.longDescription}</Description>
      <StyledRow type="flex" gutter={16}>
        {details.map((detail, index) => (
          <StyledCol span={24} md={12} lg={8} key={index}>
            <DetailsIcon type={detail.icon} />
            <Description>{detail.text}</Description>
          </StyledCol>
        ))}
      </StyledRow>
    </Row>
  );
};

export default DetailsSection;
